// IssueType values, hand-synched with PortCall.Models.Issues.Issue
export enum IssueType {
    ReservationOverlapsOther          = 'OO',
    ReservationOverlapsShift          = 'OS',
    ReservationOverlapsVesselSchedule = 'OV',
    ReservationOverlapsBerthClosure   = 'OC',
    ReservationExceedsBerthDepth      = 'BD',
    ReservationExceedsBerthLength     = 'BL',
    ReservationLacksKnownVessel       = 'KV',
    PilotJobOrderExceedsBerthDepth    = 'PD',
    ScheduleDisagreesWithEnteredDate  = 'SD',
    BerthClosureOverlapsOther         = 'CO',
}



// WEBPACK FOOTER //
// ./data/models/IssueType.ts